import React, { useState } from 'react';
import { Box, Card, CardContent, TextField, Button, Typography, Alert, CircularProgress, Link as MuiLink } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';

export default function ForgotPasswordPage() {
  const { forgotPassword, resetPassword } = useAuth();
  const [step, setStep] = useState(1);
  const [username, setUsername] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleForgot = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      await forgotPassword(username);
      setStep(2);
    } catch (err) {
      setError(err.message || 'Failed to send reset code');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      await resetPassword(username, code, newPassword);
      setSuccess('Password reset successful. You can now sign in.');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.message || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
      <Card sx={{ maxWidth: 400, width: '100%', p: 2 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>Forgot Password</Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
          {step === 1 && (
            <form onSubmit={handleForgot}>
              <TextField
                label="Email / Username" fullWidth margin="normal"
                value={username} onChange={(e) => setUsername(e.target.value)} required autoFocus
              />
              <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }} disabled={loading}>
                {loading ? <CircularProgress size={24} /> : 'Send Reset Code'}
              </Button>
            </form>
          )}
          {step === 2 && (
            <form onSubmit={handleReset}>
              <TextField
                label="Verification Code" fullWidth margin="normal"
                value={code} onChange={(e) => setCode(e.target.value)} required
              />
              <TextField
                label="New Password" type="password" fullWidth margin="normal"
                value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required
              />
              <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }} disabled={loading}>
                {loading ? <CircularProgress size={24} /> : 'Reset Password'}
              </Button>
            </form>
          )}
          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <MuiLink component={Link} to="/login">Back to Sign In</MuiLink>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
